export type VatAddress = {
  Id: number;
  CountryCode: string;
  CountryId: number;
  County: string;
  PostCode: string;
  Town: string;
  IsEu: boolean;
  IsUkForVAT: boolean;
};

export type ShippingAddress = VatAddress & {
  CompanyName: string;
  CompanyRegistrationNo: string;
  FirstName: string;
  LastName: string;
  Country: string;
  Line1: string;
  Line2: string;
  PhoneNumber: string;
};

export const empty = () => {
  return {
    Id: -1,
    CountryCode: "",
    CountryId: 0,
    County: "",
    PostCode: "",
    Town: "",
    IsEu: false,
    IsUkForVAT: false,
  };
};

export const clone = (vatAddress: VatAddress) => ({
  Id: vatAddress.Id,
  CountryId: vatAddress.CountryId,
  CountryCode: vatAddress.CountryCode,
  County: vatAddress.County,
  PostCode: vatAddress.PostCode,
  Town: vatAddress.Town,
});
